import { useCustomToast } from '@nexelem/snackbar';
import { useCustomTranslation } from '../../../../../hooks';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { FreezingBoundarySaveView, useGraphneAPI } from '@nexelem/graphne-api';
import { simulationMetaQueryKey } from './useSimulationMeta';

export const useSaveSimulationFreezingBoundaryMutation = () => {
  const api = useGraphneAPI();
  const queryClient = useQueryClient();
  const { tWrapper } = useCustomTranslation('components.toasts.commonMessage');
  const displayToast = useCustomToast();

  return useMutation({
    mutationFn: (freezingBoundarySaveView: FreezingBoundarySaveView) =>
      api.postGraphneSimulationMetadataSaveFreezingBoundary({
        freezingBoundarySaveView,
      }),
    onSuccess: (_, { simulationId }) => {
      queryClient.invalidateQueries({ queryKey: simulationMetaQueryKey(simulationId.toString()) });
    },
    onError: () => {
      displayToast({
        toastType: 'error',
        message: tWrapper('error'),
      });
    },
  });
};
